import React from 'react';
import PropTypes from 'prop-types';

import { styled } from '@mui/material/styles';
import { Box, Button, Container } from '@mui/material';
import { Link } from 'react-router-dom';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import useCloudinary from '../../../hooks/useCloudinaryImage';
import { useDevice } from '../../../hooks/useResponsive';
import VehiclesByCategory from './vehicleList';

const StyledRoot = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

export default function CategoryMobile({ category, categoryLoading }) {
  // console.log(category, 'Category1>>>>>>>>>>>');
  const { isMobile } = useDevice();

  return (
    <div>
      <StyledRoot sx={{ backgroundColor: '#121212' }}>
        <Container className="main-banner" sx={{ pb: 4, px: 2 }}>
          {/* <Typography className="featured-text" pb={1}>
            {category?.category?.name}
          </Typography>
          <Typography color={'white'} fontSize={10}>
            {category?.category?.description}
          </Typography> */}
          {isMobile ? (
            <Link to={`/category-single/${category?.category?._id}`} style={{ textDecoration: 'none' }}>
              <Box width={'100%'} mt={2}>
                {category && category?.category?.appBanners && (
                  <img
                    // src={category?.category?.appBanners[0]?.url}
                    // eslint-disable-next-line react-hooks/rules-of-hooks
                    src={useCloudinary(category?.category?.appBanners[0]?.url, 'w_400 f_auto q_auto')}
                    alt=""
                    width="100%"
                  />
                )}
              </Box>
            </Link>
          ) : (
            <Link to={`/category-single/${category?.category?._id}`} style={{ textDecoration: 'none' }}>
              {category && category?.category?.webBanners && (
                <img
                  // eslint-disable-next-line react-hooks/rules-of-hooks
                  src={useCloudinary(category?.category?.webBanners[0]?.url, 'w_400 f_auto q_auto')}
                  // src={category?.category?.webBanners[0]?.url}
                  alt=""
                  width={'100%'}
                />
              )}
            </Link>
          )}
          <VehiclesByCategory vehicles={category?.vehicles} categoryLoading={categoryLoading} />
          <Box display={'flex'} justifyContent={'center'} mt={1.5} sx={{ width: '100%' }}>
            <Link to={`/category-single/${category?.category?._id}`} style={{ textDecoration: 'none', width: '100%' }}>
              <Button
                sx={{
                  width: '100%',
                  backgroundColor: '#93642C',
                  color: '#e0e0e0',
                  fontSize: '16px',
                  borderRadius: '4px',
                  display: 'flex',
                  alignItems: 'center',
                  fontWeight: 600,
                  justifyContent: 'center', // center text & icon
                  gap: 1,
                  paddingY: '10px', // reduce top & bottom padding
                  lineHeight: 1.2, // keep text snug vertically
                  minHeight: 'unset',
                }}
              >
                View All {category?.category?.name}
                <ArrowForwardIosIcon sx={{ fontSize: '16px' }} />
              </Button>
            </Link>
          </Box>
        </Container>
      </StyledRoot>
    </div>
  );
}
CategoryMobile.propTypes = {
  category: PropTypes.object,
  categoryLoading: PropTypes.any,
};
